import React from "react";
import UserSummary from "../components/userSummary";

const SignInSuccess = () => {
	return <UserSummary forceRefreshAuthSession={false} />;
};

export default SignInSuccess;
